import React, { useEffect, useState } from 'react';
import { useGameStore } from '../store/gameStore';
import Button from '../components/Button';
import Input from '../components/Input';

const WaitingPage: React.FC = () => {
  const { 
    setScreen, 
    players, 
    isHost, 
    roomId, 
    leaveRoom,
    playerName,
    subscribeToRoom,
    currentScreen
  } = useGameStore();
  
  const [roomCode, setRoomCode] = useState('');

  useEffect(() => {
    // 방 코드 설정
    setRoomCode(roomId || 'ABC123'); // Placeholder if roomId is not yet available
    
    // Firebase 실시간 구독 시작 (한 번만)
    if (roomId) {
      console.log('🔄 WaitingPage: Firebase 구독 시작', {
        roomId,
        playerName,
        isHost,
        currentScreen
      });
      
      // 구독은 subscribeToRoom 내부에서 중복 구독을 방지함
      subscribeToRoom(roomId);
    }
  }, [roomId, playerName, isHost, currentScreen, subscribeToRoom]); // 누락된 의존성들 추가

  // 화면 전환 감지
  useEffect(() => {
    console.log('🔄 WaitingPage: 화면 상태 변경 감지', {
      currentScreen,
      roomId,
      playerName
    });
  }, [currentScreen, roomId, playerName]);

  const handleStartGame = () => {
    if (isHost) {
      console.log('🎮 방장이 게임 시작 버튼 클릭');
      setScreen('topic');
    }
  };

  const handleLeaveRoom = () => {
    // Firebase에서 플레이어 제거 및 구독 해제는 leaveRoom에서 처리
    console.log('🚪 플레이어 방 나가기:', playerName);
    leaveRoom();
    setScreen('home');
  };

  const copyRoomCode = () => {
    navigator.clipboard.writeText(roomCode);
    alert('방 코드가 복사되었습니다!');
  };

  const host = players.find(p => p.isHost);
  const playerCount = players.length;

  return (
    <div className="screen">
      <div className="container">
        <h2>게임 대기실</h2>
        
        <div className="room-info">
          <p>방장: <span>{host?.name || '로딩 중...'}</span></p>
          <p>전체 인원: <span>{playerCount}</span>명</p>
          <p>현재 화면: <span>{currentScreen}</span></p>
        </div>
        
        <div className="players-list">
          {players.length === 0 ? (
            <p>플레이어 목록을 불러오는 중...</p>
          ) : (
            players.map((player, index) => (
              <div 
                key={index} 
                className={`player-card ${player.isHost ? 'host' : ''}`}
              >
                <div className="player-info">
                  <div className="player-name">{player.name}</div>
                  <div className="player-status">
                    {player.isHost ? '방장' : '참가자'}
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
        
        <div className="room-link">
          <p>방 코드: <strong>{roomCode}</strong></p>
          <p>방 코드를 공유하세요:</p>
          <div className="link-container">
            <Input
              value={roomCode}
              onChange={() => {}} // readOnly이므로 빈 함수
              disabled={true}
            />
            <Button
              variant="secondary"
              onClick={copyRoomCode}
            >
              복사
            </Button>
          </div>
        </div>
        
        <div className="button-group">
          {isHost && (
            <Button
              variant="primary"
              onClick={handleStartGame}
              disabled={false}
            >
              게임 시작
            </Button>
          )}
          <Button
            variant="secondary"
            onClick={handleLeaveRoom}
          >
            방 나가기
          </Button>
        </div>
      </div>
    </div>
  );
};

export default WaitingPage; 